import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams,useNavigate } from 'react-router-dom';
import * as jobActions from 'actions/jobActions';
import * as clientDetailsActions from 'actions/clientDetailsActions';
import { getReferenceDataRecord } from 'selectors/referenceDataSelectors';
import JobPage from 'components/jobs/JobPage';
import { bindActionCreators } from 'redux';

const JobPageContainer = () => {
  const dispatch = useDispatch();
  const { id: jobId } = useParams();
  const navigate = useNavigate();

  // Get the current job from the state
  const currentJob = useSelector((state) => state.currentJob);
  const refData = useSelector((state)=>state.referenceData);
  // Fetch the treatment type using the current job and jobId
  const treatmentType = currentJob && currentJob.treatmentDetails && currentJob.id === jobId
    ? getReferenceDataRecord(
      refData, // Pass currentJob instead of state
        'treatmentTypes',
        'id',
        currentJob.treatmentDetails.treatmentTypeId,
        'JobDetailsSummary.treatmentType'
      )
    : null;

  // Prepare job data
  const jobData = currentJob  && currentJob.id === jobId
    ? { treatmentType, ...currentJob }
    : null;

  // Combine actions
  const actions = bindActionCreators({
    ...jobActions,
    ...clientDetailsActions
  },dispatch
  );

  return (
    <JobPage navigate={navigate} currentJob={jobData} jobId={jobId} actions={actions} />
  );
};

export default JobPageContainer;
